import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Home from "../../images/home.svg";
import ExpoActive from "../../images/expo.svg";
import Expo from "../../images/expoInactive.svg";

import Profile from "../../images/profile.svg";
import ProfileActive from "../../images/profileActive.svg";
import HomeActive from "../../images/homeActive.svg";
import LogoAvathar from "../../components/navbar/LogoAvathar";
import ToolTip from "../../components/walk-through/ToolTip";
import { useSelector } from "react-redux";
import TopNav from "./TopNav";

function BottonToggle(props) {
  const layoutWraper = useSelector((store) => store.layout.layoutWraper);

  const homeDescription =
    "Enjoy the hotel services by entering the hotel with booking iD";
  const exploreDescription = "Explore hotels, events, activities";
  const [showHomeToolTip, setShowHomeToolTip] = useState(false);
  const [showExploreToolTip, setShowExploreToolTip] = useState(false);
  const walkThroughFlag = localStorage.getItem(
    "RestrictWalkThroughInBottomToggle"
  );

  const hideHomeTooltip = () => {
    setShowHomeToolTip(false);
    setShowExploreToolTip(true);
  };

  const hideExploreTooltip = () => {
    setShowExploreToolTip(false);
    localStorage.setItem("RestrictWalkThroughInBottomToggle", 1);
  };

  const showToolTips = () => {
    setTimeout(() => {
      setShowHomeToolTip(true);
    }, 1000);
  };

  useEffect(() => {
    if (!walkThroughFlag) showToolTips();
    console.log(layoutWraper)
  }, []);

  return (
      <div>  
      {layoutWraper ?  <TopNav/> : null}
      <div className={layoutWraper ? "bottom-nav mobToggle z-10 fixed bottom-0 max-w-[550px] w-[100%] flex-col" :
         "mobToggle  z-10 fixed bottom-0 max-w-[550px] w-[100%] flex-col"}>
        <div className="flex justify-between  items-center toggle-items">
          <div className="flex items-center relative">
            <NavLink
              to="/hotel-list"
              exact
              activeClassName="active"
              className="px-5 py-1"
            >
              {({ isActive }) => (
                <div>
                  <div className="flex flex-col  items-center cursor-pointer">
                    <img
                      className="botImg"
                      src={isActive ? HomeActive : Home}
                    />
                  </div>
                  <div className="togText whitespace-nowrap mt-1">My Hotel</div>
                </div>
              )}
            </NavLink>
            {showHomeToolTip &&
              !props.login &&
              !props.logout &&
              props.EnterName !== false && (
                <ToolTip
                  position="top-right"
                  description={homeDescription}
                  arrowPosition="bottom"
                  confirmBtn="Next"
                  source="home"
                  hideHomeTooltip={hideHomeTooltip}
                />
              )}
          </div>
          <div className="flex items-center relative">
            <NavLink
              to="/"
              exact
              activeClassName="active"
              className="px-5 py-1"
            >
              {({ isActive }) => (
                <div>
                  <div className="flex flex-col  items-center cursor-pointer">
                    <img
                      className="botImg"
                      src={isActive ? Expo : ExpoActive}
                    />
                  </div>
                  <div className="togText whitespace-nowrap mt-1">Explore</div>
                </div>
              )}
            </NavLink>
            {showExploreToolTip &&
              !props.login &&
              !props.logout &&
              props.EnterName !== false && (
                <ToolTip
                  position="top-right"
                  description={exploreDescription}
                  arrowPosition="bottom"
                  confirmBtn="Ok"
                  source="explore"
                  hideExploreTooltip={hideExploreTooltip}
                />
              )}
          </div>

          <NavLink to="/profile" activeClassName="active" className="px-5 py-1">
            {({ isActive }) => (
              <div>
                <div className="flex flex-col  items-center cursor-pointer">
                  <img
                    className="botImg"
                    src={isActive ? ProfileActive : Profile}
                  />
                </div>
                <div className="togText whitespace-nowrap mt-1">My profile</div>
              </div>
            )}
          </NavLink>
        </div>
        {/* <div className="mt-4 bot mx-auto"></div> */}
      </div> 
      </div>
  );
}

export default BottonToggle;
